import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IApiResult } from '../shared/models/api-result';
import { ApiUrlProvider } from './api-url.provider';
import { Position} from '../shared/models/position';
import { PayrollTimesheet } from '../shared/models/payroll-timesheet';
import { IDateRange } from '../shared/models/date-range';
import { addDays, differenceInDays, format } from 'date-fns';
import { TimesheetSearchModel } from '../shared/models/timesheet-search-model';

@Injectable({
  providedIn: 'root'
})
export class PayrollService {
  private firstPayDay: Date = new Date(2020, 6, 6); // July 6, 2020, Monday
  
  constructor(private http: HttpClient, private apiUrlProvider: ApiUrlProvider) { }
  
  getPayrollTimesheet(dateRange: IDateRange): Observable<IApiResult<PayrollTimesheet[]>>{
    const params = new HttpParams()
    .set('fromDate', format(dateRange.range.from, "yyyy-MM-dd"))
    .set('toDate', format(dateRange.range.to, "yyyy-MM-dd"));

    return this.http.get<IApiResult<PayrollTimesheet[]>>(`${this.apiUrlProvider.url}/Payroll`, {params});    
  }

  downloadPayrollTimesheets(searchModel: TimesheetSearchModel, whenDone){
    let url = `${this.apiUrlProvider.url}/Payroll/Timesheet/download`;
    const params = new HttpParams()
      .set('fromDate', format(searchModel.fromDate, "yyyy-MM-dd"))
      .set('toDate', format(searchModel.toDate, "yyyy-MM-dd"));

    return this.http.get(url, {params, responseType: 'blob'})
      .subscribe(res => {
        let objectUrl = window.URL.createObjectURL(res);
        let imageAnchor: HTMLAnchorElement = document.createElement("a");
        imageAnchor.href = objectUrl;
        imageAnchor.target = "_blank";
        imageAnchor.download = `payroll_timesheets_${format(searchModel.fromDate, "yyyyMMdd")}_${format(searchModel.toDate, "yyyyMMdd")}.xlsx`;
        imageAnchor.click();
        window.URL.revokeObjectURL(objectUrl);
      }, _ => {}, () => { 
        if (whenDone){
          whenDone();
        }
      });
  }

  getPayPeriods(count: number): IDateRange[]{
    let today = new Date();
    let currentPeriod: IDateRange = {
      title: null,
      range: {
        to: addDays(today, 13 - (differenceInDays(today, this.firstPayDay) % 14)),
        from: null
      }
    };

    currentPeriod.range.from = addDays(currentPeriod.range.to, -13);

    let result: IDateRange[] = [];
    for (let i = 0; i < count; i ++ ){
      let range = {
        from: addDays(currentPeriod.range.from, -14 * i),
        to: addDays(currentPeriod.range.to, -14 * i)
      };

      result.push({
        title: `${format(range.from, 'dd/MM/yyyy')} - ${format(range.to, 'dd/MM/yyyy')}`,
        range: range
      });
    }

    return result;
  }

  getCurrentPayPeriod(): IDateRange{
    let today = new Date();
    let currentPeriod: IDateRange = {
      title: null,
      range: {
        to: addDays(today, 13 - (differenceInDays(today, this.firstPayDay) % 14)),
        from: null
      }
    };

    currentPeriod.range.from = addDays(currentPeriod.range.to, -13);

    return {
      title: `${format(currentPeriod.range.from, 'dd/MM/yyyy')} - ${format(currentPeriod.range.to, 'dd/MM/yyyy')}`,
      range: currentPeriod.range
    };;
  }

  getLastPayPeriod(): IDateRange{
    let currentPeriod = this.getCurrentPayPeriod();

    let range = {
      from: addDays(currentPeriod.range.from, -14),
      to: addDays(currentPeriod.range.to, -14)
    };

    return {
      title: `${format(range.from, 'dd/MM/yyyy')} - ${format(range.to, 'dd/MM/yyyy')}`,
      range: range
    };
  }
}
